import React from 'react';
import { useTranslation } from 'react-i18next';
import getLocalisedDate from 'utils/dates/getLocalisedDate';
import getRelativeOffsetValue from './getRelativeOffsetValue';
import Stack from 'components/Stack';
import Text from 'components/Text';
function NudgeDates(_ref) {
  var nudge = _ref.nudge;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isTargetDueDate = nudge.isTargetDueDate,
    targetDate = nudge.targetDate,
    scheduledDate = nudge.scheduledDate,
    targetOffset = nudge.targetOffset,
    targetOffsetUnit = nudge.targetOffsetUnit,
    targetType = nudge.targetType;
  if (!targetDate && !scheduledDate && !targetOffset) {
    return /*#__PURE__*/React.createElement(Text, null, '-');
  }
  var relativeTargetValue = getRelativeOffsetValue({
    targetOffset: targetOffset,
    targetType: targetType,
    isTargetDueDate: isTargetDueDate,
    targetOffsetUnit: targetOffsetUnit
  });
  var formattedDate = function formattedDate(date) {
    return getLocalisedDate({
      date: date,
      options: {
        month: 'short',
        year: 'numeric',
        day: 'numeric'
      },
      isInLocalTimezone: true,
      fallbackVariant: 'hyphen'
    });
  };
  var targetDateState = isTargetDueDate ? 'state_due_on_date' : 'state_target_on_date';
  return /*#__PURE__*/React.createElement(Stack, {
    spacing: "xxs",
    grow: true,
    shrink: true
  }, targetDate && /*#__PURE__*/React.createElement(Text, null, t(targetDateState, {
    date: formattedDate(targetDate)
  })), relativeTargetValue && /*#__PURE__*/React.createElement(Text, null, t(relativeTargetValue.relativeTargetOffset, {
    count: relativeTargetValue.count
  })), scheduledDate && /*#__PURE__*/React.createElement(Text, null, t('state_shared_on_date', {
    date: formattedDate(scheduledDate)
  })));
}
export default NudgeDates;